
  import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
  import {Chart} from 'chart.js';
  import {Router} from '@angular/router';
  import {Store} from '@ngrx/store';
  import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
  import {DoctorService} from '../../../../services/doctor.service';
  import {MatDialog} from '@angular/material/dialog';
  import {Observable, Subscription} from 'rxjs';
  import {MatTableDataSource} from '@angular/material/table';
  import {Patient} from '../../../../model/user/Patient';
  import {MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent} from '@angular/material/paginator';
  import {MatCheckboxChange} from '@angular/material/checkbox';
  import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-bar-chart-never-logged-activetherapy',
  templateUrl: './bar-chart-never-logged-activetherapy.component.html',
  styleUrls: ['./bar-chart-never-logged-activetherapy.component.css']
})
export class BarChartNeverLoggedActivetherapyComponent implements OnInit {
    
            // per inizializzazione
            getAuthState: Observable<any>;
            getDoctorState: Observable<any>;
            isAuthenticated: boolean;
            user = null;
            errorMessage = null;
            subscription1: Subscription;
            subscription2: Subscription;
            subscription3: Subscription;
            subscription4: Subscription;
            subscription5: Subscription;
            subscription6: Subscription;
            subscription7: Subscription;
            title = "Terapia attiva";
            destination = 'never-logged';

  
            // elementi che servono per il bar-chart
            canvas: any;
            ctx: any;
            myChartNeverLoggedPatients: Chart;
      
            // ******************************************************************************************************************
            // seguenti righe: inizializzazione dei pazienti 
            // ******************************************************************************************************************
            neverLoggedGlobal5ASA = 0;
            neverLoggedGlobalTOPICA = 0;
            neverLoggedGlobalGCSOS = 0;
            neverLoggedGlobalIMM = 0;
            neverLoggedGlobalBIO = 0;

      
            loggedGlobal5ASA = 0;
            loggedGlobalTOPICA = 0;
            loggedGlobalGCSOS = 0;
            loggedGlobalBIO = 0;
            loggedGlobalIMM = 0;
  
      
      
            GlobalPatients5ASA = 0;
            GlobalPatientsTOPICA = 0;
            GlobalPatientsGCSOS = 0;
            GlobalPatientsBIO =0;
            GlobalPatientsIMM = 0;

      
            neverLoggedGlobalPatientsArray = [];
            loggedGlobalPatientsArray = [];
            neverLoggedPatientsGlobal = [];
            // ******************************************************************************************************************
            // bar chart dei pazienti 
            // ******************************************************************************************************************
            public barChartLabelsGlobalNeverLogged = ['5-ASA-OS', 'TOPICA','GCS-OS','IMM.','BIO.'];
            public barChartTypeGlobalNeverLogged = 'horizontalBar';
            public barChartLegendGlobalNeverLogged = true;
            public barChartDataGlobalNeverLogged = [
              {
                data: this.loggedGlobalPatientsArray, label: 'Accesso effettuato', backgroundColor: ['teal', 'teal','teal', 'teal','teak'],
                hoverBackgroundColor: ['#066','066', '#066','#066','#066'],maxBarPercentage : 0.5,  // number (pixels) or 'flex'
              },
              {
                data: this.neverLoggedGlobalPatientsArray, label: 'Accesso non effettuato', backgroundColor: ['orangered', 'orangered','orangered','orangered','orangered'],
                hoverBackgroundColor: ['#cc3700','cc3700','#cc3700','cc3700','cc3700'], maxBarPercentage: 0.5,  // number (pixels) or 'flex'
              }];
            
      
      
            // constructor
            constructor(private store: Store<AppState>,
                        private doctorService: DoctorService,
                        private snackBar: MatSnackBar) {
              this.getAuthState = this.store.select(selectAuthState);
              this.getDoctorState = this.store.select(selectDoctorState);
            }
            // ******************************************************************************************************************
            // metodo all'inizio
            ngOnInit(): void {
              this.subscription7 = this.getAuthState.subscribe((state) => {
                this.isAuthenticated = state.isAuthenticated;
                this.user = JSON.parse(localStorage.getItem('user'));
                this.errorMessage = state.errorMessage;
                this.retrieveGlobalNeverLogged5ASA_Active();
              });
            }
            ngOnDestroy(): void {
              this.subscription1.unsubscribe();
              this.subscription2.unsubscribe();
              this.subscription3.unsubscribe();
              this.subscription4.unsubscribe();
              this.subscription5.unsubscribe();
              this.subscription6.unsubscribe();
              this.subscription7.unsubscribe();

            }
            // ******************************************************************************************************************
            // metodi che si richiamano in cascata e prendono tutti gli inattivi in telemedicina
            // e in standard e poi tutti
            // i pazienti in ogni categoria per poter calcolare gli attivi
            // retrieve global active and inactive patients (le funzioni si richiamano in cascata) bar chart
    
            retrieveGlobalNeverLogged5ASA_Active() {
              this.subscription1 = this.doctorService.getNeverLoggedActiveTherapyNumber("therapy5ASAOS").subscribe(npatients => {
                this.neverLoggedGlobal5ASA = parseInt(npatients.toString());
                this.neverLoggedGlobalPatientsArray.push(this.neverLoggedGlobal5ASA); // riempio il vettore del bar chart con standard
                this.retrieveGlobalNeverLoggedTOPICA_Active();
    
              }, error => {
                if (error.status === 500) {
                  localStorage.setItem('expirationTime', '0');
                  console.log('SESSIONE SCADUTA');
                  location.reload();
                }
              });
            }
            retrieveGlobalNeverLoggedTOPICA_Active() {
              this.subscription2 = this.doctorService.getNeverLoggedActiveTherapyNumber("therapyTOPICA").subscribe(npatients => {
                this.neverLoggedGlobalTOPICA = parseInt(npatients.toString());
                this.neverLoggedGlobalPatientsArray.push(this.neverLoggedGlobalTOPICA); // riempio vettore del bar-chart con telemedicina
                this.retrieveGlobalNeverLoggedGCSOS_Active();
    
              }, error => {
                if (error.status === 500) {
                  localStorage.setItem('expirationTime', '0');
                  console.log('SESSIONE SCADUTA');
                  location.reload();
                }
              });
            }
  
            retrieveGlobalNeverLoggedGCSOS_Active() {
              this.subscription3 = this.doctorService.getNeverLoggedActiveTherapyNumber("therapyGCSOS").subscribe(npatients => {
                this.neverLoggedGlobalGCSOS = parseInt(npatients.toString());
                this.neverLoggedGlobalPatientsArray.push(this.neverLoggedGlobalGCSOS); // riempio vettore del bar-chart con telemedicina
                this.retrieveGlobalNeverLoggedIMM_Active();
  
    
              }, error => {
                if (error.status === 500) {
                  localStorage.setItem('expirationTime', '0');
                  console.log('SESSIONE SCADUTA');
                  location.reload();
                }
              });
            }

            retrieveGlobalNeverLoggedIMM_Active() {
              this.subscription4 = this.doctorService.getNeverLoggedActiveTherapyNumber("therapyIMM").subscribe(npatients => {
                this.neverLoggedGlobalIMM = parseInt(npatients.toString());
                this.neverLoggedGlobalPatientsArray.push(this.neverLoggedGlobalIMM); // riempio vettore del bar-chart con telemedicina
                this.retrieveGlobalNeverLoggedBIO_Active();
  
    
              }, error => {
                if (error.status === 500) {
                  localStorage.setItem('expirationTime', '0');
                  console.log('SESSIONE SCADUTA');
                  location.reload();
                }
              });
            }
    
            retrieveGlobalNeverLoggedBIO_Active() {
              this.subscription5 = this.doctorService.getNeverLoggedActiveTherapyNumber("therapyBIO").subscribe(npatients => {
                this.neverLoggedGlobalBIO = parseInt(npatients.toString());
                this.neverLoggedGlobalPatientsArray.push(this.neverLoggedGlobalBIO); // riempio vettore del bar-chart con telemedicina
                this.retrieveGlobalActiveTherapy();
    
              }, error => {
                if (error.status === 500) {
                  localStorage.setItem('expirationTime', '0');
                  console.log('SESSIONE SCADUTA');
                  location.reload();
                }
              });
            }
          
            retrieveGlobalActiveTherapy() {
              this.subscription6 = this.doctorService.getGlobalActiveTherapyNumber().subscribe(num => {
                this.GlobalPatients5ASA = num[0];
                this.GlobalPatientsTOPICA = num[1];
                this.GlobalPatientsGCSOS = num[2];
                this.GlobalPatientsIMM = num[3];
                this.GlobalPatientsBIO = num[4];
    
                this.loggedGlobal5ASA = this.GlobalPatients5ASA - this.neverLoggedGlobal5ASA;
                this.loggedGlobalPatientsArray.push(this.loggedGlobal5ASA); // riempio il vettore del bar chart con standard           
                this.loggedGlobalTOPICA = this.GlobalPatientsTOPICA - this.neverLoggedGlobalTOPICA;
                this.loggedGlobalPatientsArray.push(this.loggedGlobalTOPICA); // riempio il vettore del bar chart con telemedicina
                this.loggedGlobalGCSOS = this.GlobalPatientsGCSOS - this.neverLoggedGlobalGCSOS;
                this.loggedGlobalPatientsArray.push(this.loggedGlobalGCSOS); // riempio il vettore del bar chart con standard           
                this.loggedGlobalIMM = this.GlobalPatientsIMM - this.neverLoggedGlobalIMM;
                this.loggedGlobalPatientsArray.push(this.loggedGlobalIMM); // riempio il vettore del bar chart con standard           
                this.loggedGlobalBIO = this.GlobalPatientsBIO - this.neverLoggedGlobalBIO;
                this.loggedGlobalPatientsArray.push(this.loggedGlobalBIO); // riempio il vettore del bar chart con standard           
                this.canvasSetting();
              }, error => {
                if (error.status === 500) {
                  localStorage.setItem('expirationTime', '0');
                  console.log('SESSIONE SCADUTA');
                  location.reload();
                }
              });
            }
           
            canvasSetting() {
                this.canvas = document.getElementById('myChartNeverLoggedActiveTherapy') as HTMLCanvasElement;
                this.ctx = this.canvas.getContext('2d');
                this.myChartNeverLoggedPatients = new Chart(this.ctx, {
                  type: this.barChartTypeGlobalNeverLogged,
                  data: {
                    labels: this.barChartLabelsGlobalNeverLogged,
                    datasets: this.barChartDataGlobalNeverLogged,
                  },
                  options: {
                    maintainAspectRatio: true,
                    responsive: true,
      
                    scales: {
                      xAxes: [{
                        display: true,
                        stacked: false,
                        ticks: {
                          fontSize: 12,
                          fontStyle: 'bold',
                          fontFamily: 'Helvetica',
                          fontColor: '#006192'
                        }
                      }],
                      yAxes: [{
                        display: true,
                        stacked: false,
                        ticks: {
                          fontSize: 12,
                          fontStyle: 'bold',
                          fontFamily: 'Helvetica',
                          fontColor: '#006192'
                        }
                      }],
                    },
                    legend: {
                     
                      display: true,
                      position: 'top',
                      labels: {
                        usePointStyle: true,
                        fontColor: '#006192',
                        fontSize: 18,
                        fontFamily: 'Helvetica',
                      }
                    },
                    tooltips: {
                      // content: '{pathology}: {number}',
                      backgroundColor: '#1c1c1c',
                      bodyFontSize: 18,
                      titleFontSize: 18,
                      cornerRadius: 5,
                      caretPadding: 10
                    },
                    title: {
                      display: true,
                      text: "N° di utenti che hanno/non hanno effettuato l'accesso",
                      fontColor: '#006192',
                      fontSize: 20,
                      fontFamily: 'Helvetica',
                    },
                    hover: {
                      mode: 'nearest',
                      intersect: true
                    }
                  }
                });
                } // dopo aver ottenuto tutti i dati creo il bar chart
            
          }
          